import '.f{position:fixed;}.ssr-plugin'
import '.cj{top:0;}.ssr-plugin'
import '.bn{left:0px;}.ssr-plugin'
import '.bo{right:0px;}.ssr-plugin'
import '.fc{bottom:0px;}.ssr-plugin'
import '.h7{background-color:rgba(0, 0, 0, 0.25);}.ssr-plugin'
import '.h8{z-index:998;}.ssr-plugin'
import '.h9{transition:opacity 0.3s ease;}.ssr-plugin'
import '.x{height:100vh;}.ssr-plugin'
import '.o{width:100%;}.ssr-plugin'
import '.ae{background-color:var(--shades-white);}.ssr-plugin'
import '.ha{transition:transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);}.ssr-plugin'
import '.hb{z-index:999;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.k{align-items:center;}.ssr-plugin'
import '.p{justify-content:space-between;}.ssr-plugin'
import '.bs{padding:1.5rem;}.ssr-plugin'
import '.hc{border-bottom:1px solid var(--gray-border);}.ssr-plugin'
import '.c2{flex-shrink:0;}.ssr-plugin'
import '.c4{flex:1;}.ssr-plugin'
import '.at{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { IconButton } from '@app/components/core/button/IconButton'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { PropsWithChildren } from 'react'
import useMediaQuery from '@app/util/useMediaQuery'

export interface DrawerProps extends PropsWithChildren {
  title: string
  open: boolean
  setOpen: (open: boolean) => void
  portal?: HTMLElement
  style?: Style
  side: 'left' | 'right'
}

export const Drawer = ({
  title,
  open,
  setOpen,
  children,
  portal: _portal,
  style,
  side,
}: DrawerProps) => {
  const isMobile = useMediaQuery()

  const translateValue = open ? '0' : side === 'left' ? '-100%' : '100%'

  return (
    <>
      {/* Overlay */}
      <div className="f cj bn bo fc h7 h8 h9"
        onClick={() => setOpen(false)}
        style={{
          opacity: open ? 1 : 0,
          pointerEvents: open ? 'auto' : 'none',}}
      />

      {/* Sidebar Panel */}
      <styled.div className="f cj x o ae ha hb a b"
        style={{
          [side]: 0,
          maxWidth: isMobile ? '100%' : '30rem',
          borderRadius: isMobile ? 0 : '1.25rem',
          boxShadow: open ? '0 0 15px rgba(0,0,0,0.15)' : 'none',
          transform: `translateX(${translateValue})`,
          ...style,
        }}
      >
        {/* Header */}
        <div className="a k p bs hc c2"
        >
          <Title.H4 style={{ margin: 0 }}>{title}</Title.H4>
          <IconButton
            icon={faXmark}
            size="small"
            variant="secondary"
            onClick={() => setOpen(false)}
          />
        </div>

        {/* Content */}
        <div className="c4 at bs"
        >
          {children}
        </div>
      </styled.div>
    </>
  )
}
